import React from 'react'
import {
  Cube,
  Logo,
  LogoAnimatedBlack,
  LogoAnimatedWhite,
  LogoSmall,
  Moon,
  Palette,
  PreviewAll,
  Sun,
  TickLarge,
  Type,
  Warn,
} from './icons'

export const iconNames = {
  cube: Cube,
  moon: Moon,
  palette: Palette,
  previewAll: PreviewAll,
  sun: Sun,
  tickLarge: TickLarge,
  type: Type,
  warn: Warn,

  logo: Logo,
  logoSmall: LogoSmall,
  logoAnimatedBlack: LogoAnimatedBlack,
  logoAnimatedWhite: LogoAnimatedWhite,
}

interface Props {
  name: keyof typeof iconNames
}

export default function Icon({ name }: Props) {
  const IconComponent = iconNames[name]
  return <IconComponent />
}
